import { Box, IconButton, TextField, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { formatLocaleCurrency } from "country-currency-map";
import * as React from "react";
import { getallTransactions } from "../../config/services";
import CustomizedSnackbars from "../components/snackbar";
import { CancelTransferButton, ConfirmTransaction } from "./compoinents";
import SearchIcon from "@mui/icons-material/Search";

export default function AllTransactions() {
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [transactions, setTransactions] = React.useState([]);

  const [transactionsConst, setTransactionsConst] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState("");

  React.useEffect(() => {
    getallTransactions().subscribe((transactions) => {
      console.log(transactions);
      setTransactions(transactions);
      setTransactionsConst(transactions);
    });
  }, []);

  const handleChange = (e) => {
    setSearchQuery(e.target.value);
    setTransactions(transactionsConst);
  };

  const search = (e) => {
    let filteredUsers = transactions.filter((user) => {
      return user.email === searchQuery || user.accountnumber === searchQuery;
    });
    setTransactions(filteredUsers);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  return (
    <>
      <CustomizedSnackbars
        openSnackbar={openSnackbar}
        handleCloseSnackbar={handleCloseSnackbar}
        severity="success"
        message={"Transaction Confirmed"}
      />
      <TableContainer>
        <Box display={"flex"} justifyContent={"center"} p={2}>
          <TextField
            id="search-bar"
            label="Search email"
            variant="outlined"
            onChange={handleChange}
            // onBlur={search}
            size="small"
            fullWidth
          />
          <IconButton
            onClick={search}
            sx={{ ml: 1 }}
            type="submit"
            aria-label="search"
          >
            <SearchIcon />
          </IconButton>
        </Box>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Status</TableCell>
              <TableCell align="left">User</TableCell>
              <TableCell align="left">Amount</TableCell>
              <TableCell align="left">Confirm</TableCell>
              <TableCell align="left">Cancel</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((row, index) => (
              <TableRow key={index}>
                <TableCell align="left">
                  <Typography color={row.pending ? "orange" : "green"}>
                    {row.pending ? "Pending" : "Comfirmed"}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography> {row.fullname}</Typography>
                  <Typography>{row.accountnumber}</Typography>
                </TableCell>
                <TableCell align="left">
                  {formatLocaleCurrency(row.amount, "USD")}
                </TableCell>

                <TableCell align="left">
                  <ConfirmTransaction
                    row={row}
                    setOpenSnackbar={setOpenSnackbar}
                  />
                </TableCell>
                <TableCell align="left">
                  <CancelTransferButton row={row} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
